/* global Sys, Services */
Sys.ns("Services");

/**
 * The Win Service.
 *
 * @class Services.Win
 * @extends Services.Base
 */
Services.Win = {
    constructor: function(config) {
        Services.Win.superclass.constructor.apply(this, arguments);

        this._winCoins = 0;
        this._winCents = 0;
        this._totalWinCoins = 0;
        this._totalWinCents = 0;
        this._winType = "noWin";
        this._presentationActive = false;
        this._celebrateWinsLowerThanBet = true;

        this._onInitResponseParsed(config.initResponse);
    },

    _setupEvents: function() {
        this.observable.on({
            "notify:stateHandler.leavingIdleState": this._reset.bind(this),
            "notify:serverManager.serverErrorReceived": this._reset.bind(this),
            "notify:responseParser.responseParsed": this.updateResponse.bind(this),
            "request:cashField.showWin": this.show.bind(this),
            "notify:standardWin.startPresentation": this._presentationStart.bind(this),
            "notify:standardWin.presentationComplete": this._presentationEnd.bind(this),
            "notify:stateHandler.enteringBigWinState": this._presentationStart.bind(this),
            "notify:bigWin.presentationFinished": this._presentationEnd.bind(this),
            "notify:winPresentation.abort": this._presentationAborted.bind(this),
            "request:coinsField.showProgressiveWin": this._progressiveWin.bind(this)
        });
    },

    /**
     * Gets the number of cents won.
     *
     * @public
     * @returns {number} The number of cents won.
     */
    getWinCash: function() {
        return this._winCents;
    },

    /**
     * Gets the number of coins won.
     *
     * @public
     * @returns {number} The number of coins won.
     */
    getWinCoins: function() {
        return this._winCoins;
    },

    /**
     * Gets the number of cents won.
     *
     * @public
     * @returns {number} The number of cents won.
     */
    getTotalWinCash: function() {
        return this._totalWinCents;
    },

    /**
     * Gets the number of coins won.
     *
     * @public
     * @returns {number} The number of coins won.
     */
    getTotalWinCoins: function() {
        return this._totalWinCoins;
    },

    /**
     * Gets the win type.
     *
     * @public
     * @returns {string} The win type (noWin, smallWin, largeWin, bigWin).
     */
    getWinType: function() {
        return this._winType;
    },

    /**
     * Shows the win.
     *
     * @public
     * @returns {void}
     */
    show: function() {
        this.publish("show");
    },

    /**
     * Gets the win presentation state: active or not.
     *
     * @public
     * @returns {boolean} Win presentation status.
     */
    isPresentationActive: function() {
        return this._presentationActive;
    },

    /**
     * Abort win presentation.
     *
     * @public
     * @returns {void}
     */
    abortPresentation: function() {
        // can be moved presentation fire event in it's own service
        // and publish from here.
        this.observable.fireEvent("request:abortPresentation");
    },

    /**
     * Update service data based on new response.
     *
     * @public
     * @param {Object} response The server response.
     * @returns {void}
     */
    updateResponse: function(response) {
        this._onResponseParsed(response);
    },

    /**
     * Resets the win information.
     *
     * @private
     * @returns {void}
     */
    _reset: function() {
        this._winCents = 0;
        this._winCoins = 0;
        this._totalWinCents = 0;
        this._totalWinCoins = 0;

        Services.storage.storeData("cashField.winInCents", 0);
        Services.storage.storeData("cashField.winInCoins", 0);
    },

    /**
     * Collects the win information from the server response.
     *
     * @private
     * @param {Object} response The server response.
     * @returns {void}
     */
    _onResponseParsed: function(response) {
        if (Sys.isDefined(response.wins)) {
            this._winCents = response.wins.cents || 0;
            this._winCoins = response.wins.coins || 0;
            this._totalWinCents = response.wins.centsTotal || 0;
            this._totalWinCoins = response.wins.coinsTotal || 0;

            this._winType = response.wins.winType || "noWin";

            Services.storage.storeData("cashField.winInCents", this._winCents);
            Services.storage.storeData("cashField.winInCoins", this._winCoins);
        }
    },

    /**
     * Collects the win information from the initial server response.
     *
     * @private
     * @param {Object} initResponse The server response.
     * @returns {void}
     */
    _onInitResponseParsed: function(initResponse) {
        this._celebrateWinsLowerThanBet = Sys.utils.getOssParameter("celebrateWinsLowerThanBet", initResponse["config.gameParameters.celebrateWinsLowerThanBet"]) !== false;

        if (initResponse.restore !== true) {
            return;
        }

        this._winCents = parseInt(initResponse["game.win.cents"], 10) || 0;
        this._winCoins = parseInt(initResponse["game.win.coins"], 10) || 0;
        this._totalWinCents = parseInt(initResponse["totalwin.cents"], 10) || 0;
        this._totalWinCoins = parseInt(initResponse["totalwin.coins"], 10) || 0;

        Services.storage.storeData("cashField.winInCents", this._winCents);
        Services.storage.storeData("cashField.winInCoins", this._winCoins);
    },

    /**
     * Sets the mode of win presentation to active and publish "presentationStart".
     *
     * @private
     * @returns {void}
     */
    _presentationStart: function() {
        this._presentationActive = true;

        this.publish("presentationStart");
    },

    /**
     * Sets the mode of win presentation to not active.
     *
     * @private
     * @returns {void}
     */
    _presentationEnd: function() {
        this._presentationActive = false;
    },

    /**
     * Publish that win presentation is aborted.
     *
     * @private
     * @returns {void}
     */
    _presentationAborted: function() {
        this.publish("presentationAborted");
    },

    /**
     * Sets the mode of win presentation to progressive win.
     *
     * @private
     * @param {boolean} resetWin Boolean value to reset win.
     * @returns {void}
     */
    _progressiveWin: function(resetWin) {
        this.publish("showProgressiveWin", resetWin);
    },

    /**
     * Shows if current total win should be celebrated.
     *
     * @returns {boolean} True if current total win should be celebrated.
     */
    shouldCelebrateWin: function() {
        var win = this.getTotalWinCoins(),
            bet = Services.moneyManager.getBetCoins();

        return win > 0 && (this._celebrateWinsLowerThanBet || win >= bet);
    }

};

Services.Win = Sys.extend(Services.Base, Services.Win, "Services.Win");
